
export const IMAGE_API_KEY = "BMn6nPTxTBHomlODqrIt8BPUXMc2s88C69YcTzGogvbldquV4+u5uHWY2RkA1kixyHlay6X0P+LdgfvG+GXiU6di0LV+GUhbm3Z99WbdkYbSdE5iM6Txcc+KBOhcMlW9r224qy9ilbO/VCqbE3QveO1h6lk60BCWmOe6WIuOqSg="
export const API_KEY = 'sd@k43s4jk34l3l4fdjqwrle243kk4';
const currentClient = 'arolisa';// 'garmenzo'; // arolisa

interface ClientConfig {
    API_URL: string;
    IMAGE_API_URL: string;
    IMAGE_BASE_URL: string;
    APP_NAME: string;
    IMAGE_FOLDER: string;
    INVOICE_URL: string;
    APP_LOGO: string;
    MULTI_BRAND: boolean; 
    FAV_ICON: string; // Optional favicon property
    NO_DISCOUNT: boolean;
}

// Define configurations for different clients
const CLIENT_CONFIGS: Record<string, ClientConfig> = {
    qa: {
        API_URL: 'https://qa.api.garmenzo.com/api/v1',
        IMAGE_API_URL: 'https://imgdb.plentima.com/api',
        IMAGE_BASE_URL: 'https://imgdb.plentima.com/qa/',
        APP_NAME: "QA",
        IMAGE_FOLDER: 'qa',
        INVOICE_URL: 'https://qa.api.garmenzo.com',
        APP_LOGO: 'assets/images/Plentima-Logo.png',
        MULTI_BRAND: true ,
        FAV_ICON: 'assets/images/plentima-favicon.ico', 
        NO_DISCOUNT: false,
    },
    plentima: {
        API_URL: 'https://qa.api.garmenzo.com/api/v1',
        IMAGE_API_URL: 'https://imgdb.plentima.com/api',
        IMAGE_BASE_URL: 'https://imgdb.plentima.com/qa/',
        APP_NAME: "qa",
        IMAGE_FOLDER: 'qa',
        INVOICE_URL: 'https://qa.api.garmenzo.com',
        APP_LOGO: 'assets/images/Plentima-Logo.png',
        MULTI_BRAND: true ,
        FAV_ICON: 'assets/images/plentima-favicon.ico', 
        NO_DISCOUNT: false,

    },
    garmenzo: {
        API_URL: 'https://api.garmenzo.com/api/v1',
        IMAGE_API_URL: 'https://imgdb.plentima.com/api',
        IMAGE_BASE_URL: 'https://imgdb.plentima.com/garmenzo/',
        APP_NAME: "Garmenzo",
        IMAGE_FOLDER: 'garmenzo',
        INVOICE_URL: 'https://api.garmenzo.com',
        APP_LOGO: 'assets/images/logo-dark.png',
        MULTI_BRAND: true ,
        FAV_ICON: 'assets/images/favicon.ico', 
        NO_DISCOUNT: false,
    },
    arolisa: {
        API_URL: 'https://arolisa.api.garmenzo.com/api/v1',
        IMAGE_API_URL: 'https://imgdb.plentima.com/api',
        IMAGE_BASE_URL: 'https://imgdb.plentima.com/arolisa/',
        APP_NAME: "Plentima",
        IMAGE_FOLDER: 'arolisa',
        INVOICE_URL: 'https://arolisa.api.garmenzo.com',
        APP_LOGO: 'assets/images/Plentima-Logo.png',
        MULTI_BRAND: true ,
        FAV_ICON: 'assets/images/plentima-favicon.ico',
        NO_DISCOUNT: true,
    }
};

// Function to get client configuration
export const getClientConfig = (clientId: string): ClientConfig => {
    return CLIENT_CONFIGS[clientId] || CLIENT_CONFIGS['garmenzo']; // Default to 'garmenzo' if clientId not found
};

const config = getClientConfig(currentClient);

export const API_URL = config.API_URL;
export const IMAGE_API_URL = config.IMAGE_API_URL;
export const IMAGE_BASE_URL = {
    main: `${config.IMAGE_BASE_URL}`,
    productThumbnail: `${config.IMAGE_BASE_URL}products/t/`,
    productFull: `${config.IMAGE_BASE_URL}products/f/`,
    profile: `${config.IMAGE_BASE_URL}profile/`,
    brandThumbnail: `${config.IMAGE_BASE_URL}brands/t/`,
    brandFull: `${config.IMAGE_BASE_URL}brands/f/`,
    categoryThumbnail: `${config.IMAGE_BASE_URL}categories/t/`,
    categoryFull: `${config.IMAGE_BASE_URL}categories/f/`,
    businessDocument: `${config.IMAGE_BASE_URL}businessDocs/o/`,
    bannerThumbnail: `${config.IMAGE_BASE_URL}banners/t/`,
    bannerFull: `${config.IMAGE_BASE_URL}banners/f/`,
};
export const APP_NAME = config.APP_NAME;
export const IMAGE_FOLDER = config.IMAGE_FOLDER;
export const INVOICE_URL = config.INVOICE_URL;
export const APP_LOGO = config.APP_LOGO;
export const MULTI_BRAND = config.MULTI_BRAND; // true or false based on the client configuration
export const FAV_ICON = config.FAV_ICON; // Optional favicon property
export const NO_DISCOUNT = config.NO_DISCOUNT; // true or false based on the client configuration